// extracted by mini-css-extract-plugin
export var button = "_6p-7";
export var buttonRow = "_6p-6";
export var fadeIn = "_6p-1";
export var gradient = "_6p-0";
export var panel = "_6p-2";
export var panelIn = "_6p-3";
export var subtitle = "_6p-5";
export var title = "_6p-4";